/*
    Created by Phat Hoang Pham
    phat@launchdeck.org
*/

import React, { PureComponent } from 'react';
import { View, Text } from 'react-native-web';
import PropTypes from 'prop-types';
import * as Animatable from 'react-native-animatable';

import { Button } from './component_button';
import LoadingView from './component_loading_view';

import GLOBAL from '../configs/config_global';
import moment from 'moment/moment';

export default class ReminderActionArea extends PureComponent {
    // region Props
    static propTypes = {
        cateringData: PropTypes.object,
        text: PropTypes.string,
        onConfirm: PropTypes.func,
        onDecline: PropTypes.func,
        isLoadingAction: PropTypes.bool
    };

    static defaultProps = {
        cateringData: {},
        text: 'Can you make it to the catering event?',
        onConfirm: () => {},
        onDecline: () => {},
        isLoadingAction: false
    };
    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const {
            cateringData,
            text,
            onConfirm,
            onDecline,
            isLoadingAction
        } = this.props;

        return(
            <View
                style={{
                    width: '100%', alignSelf: 'center', backgroundColor: 'white',
                    marginTop: 32, paddingBottom: 32
                }}>
                <View style={{ width: '100%', alignSelf: 'center', alignItems: 'center', paddingHorizontal: 64 }}>
                    <Text style={{ fontSize: 16, color: GLOBAL.COLOR.BASIC.BLACK_TWO, marginVertical: 24, textAlign: 'center', alignSelf: 'stretch', fontWeight: 'bold' }}>
                        {text}
                    </Text>

                    <View style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch' }}>
                        <Button
                            onPress={onDecline}
                            locked={!onDecline}
                            style={{ backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY, flex: 1, marginRight: 4 }}
                            text={`Can't make it`}
                            textColor={'black'}
                            textStyle={{ letterSpacing: 0.5, fontWeight: 'bold' }}
                        />

                        {
                            moment.unix(cateringData?.timeObj?.startTime).isSame(moment(), 'week') &&
                            <Button
                                onPress={onConfirm}
                                locked={!onConfirm}
                                style={{ backgroundColor: GLOBAL.COLOR.MAIN, flex: 1, marginLeft: 4 }}
                                text={'Confirmed'}
                                textColor={'white'}
                                textStyle={{ letterSpacing: 0.5, fontWeight: 'bold' }}
                            />
                        }
                    </View>
                </View>

                {isLoadingAction && <LoadingView isAbsolute={true}/>}
            </View>
        );
    }
    // endregion
}
